import React, { useEffect, useRef, useState } from "react";
import ActiveItemDivider from "./ActiveItemDivider";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Mousewheel, Scrollbar } from "swiper/modules";
import { getFilteredMatches } from "utils/crafting";
import useGetIdentityMatchesInventory from "hooks/useGetIdentityMatchesInventory";
import CraftIdentityMatchesActions from "components/craft-identity/CraftIdentityMatchesActions";
import CraftIdentityMatchesItemButton from "components/craft-identity/CraftIdentityMatchesItemButton";
import ActiveItemIdentityMatchesDetails from "./ActiveItemIdentityMatchesDetails";

const ActiveItemIdentityMatches = ({ parentSwiper, item }) => {
  const matchesRef = useRef(null);
  const [sortType, setSortType] = useState("Ready to Craft");
  const [searchMatchesInput, setSearchMatchesInput] = useState("");
  const [matches, setMatches] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const updateMatchesRef = () => {
    if (matches.current) {
      matchesRef.current.update();
    }
  };
  const stopParent = () => (parentSwiper.current.enabled = false);
  const startParent = () => (parentSwiper.current.enabled = true);

  useGetIdentityMatchesInventory(item, setIsLoading, setMatches);

  const filteredMatches = getFilteredMatches(
    matches,
    searchMatchesInput,
    sortType,
    setSortType
  );

  const getColor = (item) => {
    const data = [
      item.birth_day.status,
      item.birth_month.status,
      item.birth_year.status,
      item.category.status,
    ];

    const filtered = data.filter((status) => status === "Not Owned");

    if (filtered.length > 2) {
      return "#ffffff";
    } else if (filtered.length === 2) {
      return "#f6360c";
    } else if (filtered.length === 1) {
      return "#f5e417";
    } else {
      return "#06ce22";
    }
  };

  useEffect(() => {
    setSearchMatchesInput("");
  }, [matches]);

  useEffect(() => {
    updateMatchesRef()
  }, [searchMatchesInput])

  const getComponent = () => {
    if (isLoading) {
      return (
        <p className="card-details__craft-empty">
          <span className="card-details__craft-empty-loader">
            Loading process...
          </span>
        </p>
      );
    }

    if (isLoading === false && (!filteredMatches || !filteredMatches.length)) {
      return <p className="card-details__craft-empty">No Identity matches</p>;
    }

    return (
      <Swiper
      onSwiper={(swiper) => {
        matchesRef.current = swiper;
      }}
        className="card-details__craft-list-wrapper"
        direction={"vertical"}
        slidesPerView={"auto"}
        freeMode={true}
        mousewheel={{
        releaseOnEdges: true
      }}
        scrollbar={{
          draggable: true,
          snapOnRelease: false,
        }}
        modules={[FreeMode, Mousewheel, Scrollbar]}
        onTouchStart={stopParent}
        onTouchEnd={startParent}
      >
        <SwiperSlide>
          <ul className="card-details__craft-list">
            {filteredMatches.map((item) => (
              <li className="card-details__craft-item" key={item.id}>
                <CraftIdentityMatchesItemButton
                  matchesRef={matchesRef}
                  color={getColor(item)}
                  variables={[item.custom_one, item.custom_two]}
                >
                  {item.name}
                </CraftIdentityMatchesItemButton>
                <ActiveItemIdentityMatchesDetails item={item} />
              </li>
            ))}
          </ul>
        </SwiperSlide>
      </Swiper>
    );
  };

  return (
    <>
      <section
        className="card-details__card card-details__card--matches"
        onMouseEnter={stopParent}
        onMouseLeave={startParent}
      >
        <h3 className="card-details__title">
          Identity matches
          <span className="card-details__title-subtitle">
            This date matches following identities.
          </span>
        </h3>
        <CraftIdentityMatchesActions
          matchesLength={matches.length}
          isMatchesLoading={isLoading}
          updateMatchesRef={updateMatchesRef}
          searchMatchesInput={searchMatchesInput}
          setSearchMatchesInput={setSearchMatchesInput}
          sortType={sortType}
          setSortType={setSortType}
        />
        {getComponent()}
      </section>
      <ActiveItemDivider />
    </>
  );
};

export default React.memo(ActiveItemIdentityMatches);
